/**
* @license Apache-2.0
*
* Copyright (c) 2022 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import constructorName from '@stdlib/utils/constructor-name';
import ctor2dtype from './ctor2dtype.js';
import CTORS from './ctors.js';
import DTYPES from './dtypes.js';


// VARIABLES //

var NTYPES = DTYPES.length;


// MAIN //

/**
* Returns the data type of a complex number.
*
* @param {*} value - input value
* @returns {(string|null)} data type
*
* @example
* import Complex128 from '@stdlib/complex/float64/ctor';
*
* var dt = dtype( new Complex128( 1.0, 2.0 ) );
* // returns 'complex128'
*
* var dt = dtype( 'beep' );
* // returns null
*/
function dtype( value ) {
	var i;
	for ( i = 0; i < NTYPES; i++ ) {
		if ( value instanceof CTORS[ i ] ) {
			return DTYPES[ i ];
		}
	}
	// If the above failed, fall back to a more robust (and significantly slower) means for resolving underlying data types:
	return ctor2dtype[ constructorName( value ) ] || null;
}


// EXPORTS //

export default dtype;
